var _defs, _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1113.6969 220.90872",
    xmlSpace: "preserve",
    width: 1113.6969,
    height: 220.90872,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 686.10558,
    y: 169.45753,
    width: 438.56981,
    height: 187.16399,
    id: "rect4868"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;}\n\t.st2{fill:#0898B8;}\n\t.st3{fill:#7FC142;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g79",
    transform: "translate(-193.1031,-639.53474)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.07339,
    y1: 746.84857,
    x2: 434.76129,
    y2: 746.84857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FC142"
    },
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#45AC72"
    },
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0898B8"
    },
    id: "stop8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 314.5,854 c -14.5,-0.1 -28.6,-2.5 -42.5,-6.5 -22,-6.2 -40.5,-17.8 -54.8,-35.6 -12.3,-15.2 -20.3,-32.4 -23,-51.9 -2.9,-20.5 -0.1,-40.2 9,-58.9 6.2,-12.8 15,-23.7 26,-32.8 12.2,-10 25.7,-17.7 40.9,-22.2 16.9,-5.1 34.3,-7.2 52,-6.4 16.5,0.8 32.4,3.9 47.7,10.3 20.3,8.5 37,21.3 49.2,39.8 7.5,11.4 12.3,23.9 14.4,37.5 1.6,10.2 2,20.5 0.8,30.9 -1.7,14.4 -6.5,27.9 -14.2,40.1 -15.6,24.8 -37.8,41.1 -65.8,49.7 -9.3,2.9 -18.8,4.6 -28.4,5.3 -3.9,0.4 -7.6,0.5 -11.3,0.7 z M 275,755.7 c -1,-4.7 -1.2,-12 -0.2,-18.8 1.8,-13.3 7.4,-24.8 16.6,-34.5 10.4,-11.1 23.3,-17.6 38.4,-19.5 12.5,-1.5 24.5,0.4 35.7,6.4 13.7,7.4 23.2,18.6 29.3,32.7 7.4,17.1 8,34.8 4.6,52.8 -2.7,13.8 -8.7,26.1 -17.4,37.2 -0.6,0.7 -1.2,1.5 -1.7,2.2 0.4,0 0.8,-0.2 1,-0.4 6.6,-5.2 12.5,-11.2 17.2,-18.3 13.5,-20.2 18,-42.3 13,-66 -4.2,-20.3 -14.8,-36.7 -31.3,-49.3 -12.2,-9.3 -26,-14.7 -41.3,-16.5 -9.8,-1.1 -19.6,-0.7 -29.3,1.4 -12.6,2.7 -23.6,8.3 -33.5,16.5 -8,6.6 -14.7,14.3 -19.5,23.6 -7.7,14.8 -9.3,30.4 -6.5,46.6 2,11.1 7,20.8 15.3,28.6 12.7,11.7 30.5,13 44.7,5.5 11.7,-6.1 18.9,-16 22,-28.8 1.4,-6 4.9,-10.5 10.3,-13.5 3.6,-2 7.6,-2.7 11.7,-2.4 0.5,4.9 0.5,9.7 -0.2,14.5 -1.8,13.5 -7.4,25.3 -16.8,35.2 -11.2,11.7 -25,18.2 -41.2,19.5 -11.5,0.9 -22.5,-1.2 -32.7,-6.6 -14.5,-7.8 -24.3,-19.8 -30.4,-34.9 -6,-14.9 -6.7,-30.3 -4.3,-45.9 2.5,-16.2 9.3,-30.4 19.9,-42.9 1,-1.1 1.9,-2.3 2.9,-3.4 -0.5,0 -0.8,0.2 -1.2,0.5 -10.1,7.4 -18.2,16.6 -24.1,27.5 -9.4,17.3 -12.7,35.8 -9.6,55.3 2.5,15.9 8.8,30.2 19.6,42.1 23.3,25.7 52.2,33.8 85.7,26.3 13.3,-3 24.6,-10 34.5,-19.2 8.9,-8.2 15.7,-17.9 19.7,-29.4 3.7,-10.7 4.6,-21.7 3.4,-33 -1.3,-12 -5.6,-22.8 -13.9,-31.7 -11.4,-12.3 -27.3,-15.4 -41.9,-10 -15.6,5.8 -24.6,17.6 -27.5,33.9 -1.7,10 -10.9,17.6 -21,16.7 z",
    id: "path11",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1108.6,709.9 c 0,6.8 -5.2,12.4 -12,12.9 -3.1,0.2 -6.2,0.1 -9.4,0.1 -1.3,0 -1.3,0 -1.3,1.3 0,24.3 0,48.6 0,72.9 0,0.3 0.1,0.7 0,1 -0.1,0.3 -0.4,0.7 -0.6,0.7 -4.7,0.1 -9.5,0.2 -13.9,-1.8 -7.8,-3.5 -12.8,-9.2 -14.6,-17.6 -0.2,-1.1 -0.3,-2.3 -0.3,-3.4 0,-12.3 0,-24.6 -0.1,-36.9 0,-5 -0.1,-10 -0.1,-15 0,-0.1 0,-0.3 0,-0.4 v -1.1 h -12.1 v -26.1 c 3.7,0 7.4,0 11.2,0 0.9,0 1,-0.5 1,-1.2 0,-7.2 0,-14.4 0,-21.5 0,-1.5 0,-1.5 1.5,-1.5 h 26.8 c 1.3,0 1.3,0 1.3,1.3 0,7.2 0,14.4 0,21.6 0,1.2 0,1.2 1.2,1.2 6.7,0 13.4,0 20.1,0 1.3,0 1.3,0 1.3,1.3 0,4.1 0,8.2 0,12.2 z",
    id: "path57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1206.9,730.1 c 0,-21.3 0,-42.7 0,-64 0,-2 0,-2 2,-2 9,0 18,0.1 27,0 1.4,0 1.9,0.3 1.9,1.8 -0.1,42.8 -0.1,85.5 -0.1,128.3 0,1.4 -0.4,1.8 -1.8,1.8 -9.1,-0.1 -18.2,-0.1 -27.3,0 -1.4,0 -1.8,-0.4 -1.8,-1.8 0.1,-21.3 0.1,-42.7 0.1,-64.1 0,0 0,0 0,0 z",
    id: "path59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1245.3,747.8 c 1.1,-0.7 2.2,-1.4 3.2,-2.1 2.3,-1.7 3.2,-4.4 4.4,-6.7 1.7,-3.2 3.3,-6.5 5,-9.8 3.4,-6.4 6.9,-12.9 10.4,-19.2 1.4,-2.6 3.7,-4.3 6.3,-5.7 4.8,-2.4 9.9,-2.9 15.1,-2.8 4.3,0.1 8.6,0 12.9,0 0.5,0 1,0.1 1.7,0.1 -0.2,0.6 -0.4,1 -0.6,1.3 -3.2,6.2 -6.3,12.4 -9.5,18.7 -1.2,2.4 -2.3,4.9 -3.6,7.3 -1.5,2.9 -3.2,5.7 -4.8,8.6 -1.2,2.2 -2.1,4.5 -3.4,6.5 -0.7,1.1 -2,2 -3.1,2.9 -0.8,0.7 -0.9,1.3 0,1.7 2.4,1.3 3.6,3.5 4.7,5.9 1.5,3.1 3.2,6.1 4.9,9.2 3.4,6.3 6.9,12.6 10.3,19 1.7,3.1 3.2,6.2 4.9,9.3 0.8,1.4 1.7,2.8 2.7,4.5 -0.7,0.1 -1.1,0.1 -1.5,0.1 -6.8,0 -13.7,0.2 -20.5,-0.1 -7.2,-0.2 -12.7,-3.3 -16,-10.1 -2.9,-6.1 -6.2,-12 -9.4,-17.9 -2.7,-5 -5.6,-9.8 -8.2,-14.8 -1.4,-2.7 -2.5,-3.2 -5.9,-5.9 z",
    id: "path61"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 521.7,702.7 c 0,12.1 -7.5,22.7 -18.8,27.1 -0.1,0 -0.2,0.1 -0.3,0.1 -0.1,0 -0.1,0 -0.2,0.1 -7.4,3 -12.2,10.3 -12.2,18.2 v 48.8 0 c -16,0 -29,-13 -29,-29 v -65.2 h 4.7 c 4.4,0 8.7,1 12.5,3.2 5.5,3.1 9.5,8.2 9.5,15 v 0.8 c 3.3,-6.4 7.5,-12.2 12.7,-15.9 5.2,-3.6 8.3,-5.3 13.9,-5.8 2.3,-0.2 5.5,0.1 7.1,0.4 v 2.2 z",
    id: "path63",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 939,729.6 v -65.1 h -29 v 65.1 43.8 c 0,8.1 2.3,14.4 6.8,18.8 4.5,4.4 10.9,6.6 19.2,6.6 1,0 2.1,0 3.1,-0.1 v -33.9 z",
    id: "path65",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 545.6,760.4 c 0.3,2.1 1,3.9 2,5.5 3.2,5 7.9,7.7 13.7,8.7 3.6,0.6 7.3,0.5 10.8,-0.5 1.8,-0.5 3.4,-1.4 4.9,-2.5 3.4,-2.5 7.1,-4.2 11.3,-4.8 0.9,-0.1 1.9,-0.2 2.8,-0.2 6.2,0 12.3,0 18.5,0 0.3,0 0.5,0 0.9,0 -0.1,0.4 -0.2,0.7 -0.4,0.9 -3.2,7.3 -7.5,13.8 -13.4,19.2 -6.9,6.3 -14.9,10.5 -24.3,11.8 -14.1,1.9 -26.8,-1.6 -37.8,-10.7 -9.2,-7.6 -14.8,-17.4 -16.8,-29.2 -1.7,-10.1 -0.3,-19.9 4,-29.1 4.9,-10.4 12.6,-18.2 22.9,-23.3 5,-2.4 10.3,-3.9 15.8,-4.4 8.3,-0.8 16.3,0.4 23.9,3.7 6.9,3 12.7,7.4 17.4,13.2 4.4,5.4 7.6,11.4 9.4,18.1 1,3.6 1.5,7.2 1.7,10.9 0.2,4 -0.1,7.9 -0.4,11.8 -0.1,0.8 -0.5,0.9 -1.1,0.9 -21.5,0 -43.1,0 -64.6,0 -0.3,0 -0.7,0 -1.2,0 z m 39,-21.9 c -0.1,-0.4 -0.1,-0.7 -0.2,-1 -1.7,-4.4 -4.7,-7.6 -8.8,-9.6 -6.2,-3 -12.5,-3.1 -18.9,-0.7 -4.9,1.9 -8.5,5.4 -10.4,10.5 -0.1,0.2 -0.1,0.5 -0.2,0.8 12.8,0 25.6,0 38.5,0 z",
    id: "path67",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 975.6,760.4 c 0.3,2.1 1,3.9 2,5.5 3.2,5 7.9,7.7 13.7,8.7 3.6,0.6 7.3,0.5 10.8,-0.5 1.8,-0.5 3.4,-1.4 4.9,-2.5 3.4,-2.5 7.1,-4.2 11.3,-4.8 0.9,-0.1 1.9,-0.2 2.8,-0.2 6.2,0 12.3,0 18.5,0 0.3,0 0.5,0 0.9,0 -0.1,0.4 -0.2,0.7 -0.4,0.9 -3.2,7.3 -7.5,13.8 -13.4,19.2 -6.9,6.3 -14.9,10.5 -24.3,11.8 -14.1,1.9 -26.8,-1.6 -37.8,-10.7 -9.2,-7.6 -14.8,-17.4 -16.8,-29.2 -1.7,-10.1 -0.3,-19.9 4,-29.1 4.9,-10.4 12.6,-18.2 22.9,-23.3 5,-2.4 10.3,-3.9 15.8,-4.4 8.3,-0.8 16.3,0.4 23.9,3.7 6.9,3 12.7,7.4 17.4,13.2 4.4,5.4 7.6,11.4 9.4,18.1 1,3.6 1.5,7.2 1.7,10.9 0.2,4 -0.1,7.9 -0.4,11.8 -0.1,0.8 -0.5,0.9 -1.1,0.9 -21.5,0 -43.1,0 -64.6,0 -0.3,0 -0.7,0 -1.2,0 z m 39,-21.9 c -0.1,-0.4 -0.1,-0.7 -0.2,-1 -1.7,-4.4 -4.7,-7.6 -8.8,-9.6 -6.2,-3 -12.5,-3.1 -18.9,-0.7 -4.9,1.9 -8.5,5.4 -10.4,10.5 -0.1,0.2 -0.1,0.5 -0.2,0.8 12.8,0 25.6,0 38.5,0 z",
    id: "path69",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1130.8,760.4 c 0.3,2.1 1,3.9 2,5.5 3.2,5 7.9,7.7 13.7,8.7 3.6,0.6 7.3,0.5 10.8,-0.5 1.8,-0.5 3.4,-1.4 4.9,-2.5 3.4,-2.5 7.1,-4.2 11.3,-4.8 0.9,-0.1 1.9,-0.2 2.8,-0.2 6.2,0 12.3,0 18.5,0 0.3,0 0.5,0 0.9,0 -0.1,0.4 -0.2,0.7 -0.4,0.9 -3.2,7.3 -7.5,13.8 -13.4,19.2 -6.9,6.3 -14.9,10.5 -24.3,11.8 -14.1,1.9 -26.8,-1.6 -37.8,-10.7 -9.2,-7.6 -14.8,-17.4 -16.8,-29.2 -1.7,-10.1 -0.3,-19.9 4,-29.1 4.9,-10.4 12.6,-18.2 22.9,-23.3 5,-2.4 10.3,-3.9 15.8,-4.4 8.3,-0.8 16.3,0.4 23.9,3.7 6.9,3 12.7,7.4 17.4,13.2 4.4,5.4 7.6,11.4 9.4,18.1 1,3.6 1.5,7.2 1.7,10.9 0.2,4 -0.1,7.9 -0.4,11.8 -0.1,0.8 -0.5,0.9 -1.1,0.9 -21.5,0 -43.1,0 -64.6,0 -0.3,0 -0.7,0 -1.2,0 z m 38.9,-21.9 c -0.1,-0.4 -0.1,-0.7 -0.2,-1 -1.7,-4.4 -4.7,-7.6 -8.8,-9.6 -6.2,-3 -12.5,-3.1 -18.9,-0.7 -4.9,1.9 -8.5,5.4 -10.4,10.5 -0.1,0.2 -0.1,0.5 -0.2,0.8 12.9,0 25.7,0 38.5,0 z",
    id: "path71"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 649.3,752.4 c -0.1,-6.2 0.3,-12.1 3.6,-17.5 3.2,-5.2 8.1,-7.8 13.9,-8.9 3.7,-0.7 7.4,-0.6 11,0.5 1.8,0.6 3.5,1.4 5.1,2.6 3.5,2.5 7.3,4.3 11.6,4.9 0.9,0.1 1.9,0.2 2.9,0.2 6.3,0 12.6,0 18.8,0 0.3,0 0.5,0 0.9,0 -0.1,-0.4 -0.2,-0.7 -0.4,-1 -3.3,-7.4 -7.7,-14.1 -13.7,-19.6 -7.1,-6.4 -15.2,-10.7 -24.8,-12 -14.4,-2 -27.4,1.7 -38.6,10.9 -9.4,7.8 -15.1,17.8 -17.2,29.8 -0.4,2.4 -0.6,4.8 -0.7,7.2 v 0 c 0,0.2 0,0.3 0,0.5 0,0.2 0,0.3 0,0.5 v 0 c 0.1,2.4 0.3,4.8 0.7,7.2 2,12 7.8,22 17.2,29.8 11.2,9.3 24.2,12.9 38.6,10.9 9.6,-1.3 17.7,-5.6 24.8,-12 6,-5.5 10.4,-12.2 13.7,-19.6 0.1,-0.3 0.2,-0.6 0.4,-1 -0.4,0 -0.6,0 -0.9,0 -6.3,0 -12.6,0 -18.8,0 -0.9,0 -1.9,0.1 -2.9,0.2 -4.3,0.6 -8.1,2.4 -11.6,4.9 -1.6,1.1 -3.2,2 -5.1,2.6 -3.6,1.1 -7.3,1.2 -11,0.5 -5.9,-1 -10.7,-3.7 -13.9,-8.9 -2.2,-2.8 -3.6,-9.5 -3.6,-12.7 z",
    id: "path73",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 835.1,752.4 c -0.1,-6.2 0.3,-12.1 3.6,-17.5 3.2,-5.2 8.1,-7.8 13.9,-8.9 3.7,-0.7 7.4,-0.6 11,0.5 1.8,0.6 3.5,1.4 5.1,2.6 3.5,2.5 7.3,4.3 11.6,4.9 0.9,0.1 1.9,0.2 2.9,0.2 6.3,0 12.6,0 18.8,0 0.3,0 0.5,0 0.9,0 -0.1,-0.4 -0.2,-0.7 -0.4,-1 -3.3,-7.4 -7.7,-14.1 -13.7,-19.6 -7.1,-6.4 -15.2,-10.7 -24.8,-12 -14.4,-2 -27.4,1.7 -38.6,10.9 -9.4,7.8 -15.1,17.8 -17.2,29.8 -0.4,2.4 -0.6,4.8 -0.7,7.2 v 0 c 0,0.2 0,0.3 0,0.5 0,0.2 0,0.3 0,0.5 v 0 c 0.1,2.4 0.3,4.8 0.7,7.2 2,12 7.8,22 17.2,29.8 11.2,9.3 24.2,12.9 38.6,10.9 9.6,-1.3 17.7,-5.6 24.8,-12 6,-5.5 10.4,-12.2 13.7,-19.6 0.1,-0.3 0.2,-0.6 0.4,-1 -0.4,0 -0.6,0 -0.9,0 -6.3,0 -12.6,0 -18.8,0 -0.9,0 -1.9,0.1 -2.9,0.2 -4.3,0.6 -8.1,2.4 -11.6,4.9 -1.6,1.1 -3.2,2 -5.1,2.6 -3.6,1.1 -7.3,1.2 -11,0.5 -5.9,-1 -10.7,-3.7 -13.9,-8.9 -2.1,-2.8 -3.5,-9.5 -3.6,-12.7 z",
    id: "path75",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 785.6,774.8 27.6,-71.9 c 0,-0.1 0,-0.1 -0.1,-0.1 -1.2,0 -2.4,0.1 -3.6,0.2 -7.6,0.7 -14.7,3.4 -20.6,7.6 -6.9,4.9 -12.3,12 -15.2,20.4 0,0 -2.6,7.4 -5.4,15.6 -2.1,6.2 -4.4,12.7 -5.8,16.8 L 751.4,731 c -1.4,-4.2 -3.5,-8.1 -6.1,-11.5 -0.6,-0.9 -1.3,-1.7 -2,-2.5 -0.4,-0.4 -0.7,-0.8 -1.1,-1.2 -0.4,-0.4 -0.7,-0.8 -1.1,-1.1 -1.5,-1.5 -3.2,-2.9 -4.9,-4.1 -1.3,-0.9 -2.6,-1.8 -4,-2.6 -0.5,-0.3 -0.9,-0.5 -1.4,-0.8 -0.5,-0.2 -1,-0.5 -1.4,-0.7 -0.5,-0.2 -1,-0.4 -1.5,-0.6 0,0 0,0 0,0 -0.5,-0.2 -1,-0.4 -1.5,-0.6 -0.5,-0.2 -1,-0.4 -1.5,-0.5 -0.5,-0.2 -1,-0.3 -1.5,-0.5 -0.5,-0.1 -1,-0.3 -1.6,-0.4 -2.1,-0.5 -4.3,-0.9 -6.5,-1 -0.5,0 -1.1,-0.1 -1.6,-0.1 -0.6,0 -1.1,0 -1.7,0 -0.1,0 -0.1,0.1 -0.1,0.1 l 36.3,94.4 c 0,0 0,0 0,0.1 -1,4 -2.4,7.1 -3.3,9.6 -0.8,2.5 -2,4.8 -3.2,6.4 -2.3,3.1 -2.3,3.1 -6.3,7 -0.1,0.1 -0.2,0.2 -0.3,0.3 -0.1,0.1 -0.2,0.2 -0.3,0.3 -0.8,0.8 -2,2 -3.3,3.3 -0.2,0.2 -0.4,0.5 -0.7,0.7 -1.5,1.6 -3.2,3.5 -4.7,5.2 -0.1,0.2 -0.3,0.4 -0.4,0.5 -0.9,1.1 -1.7,2.2 -2.3,3.1 -0.1,0.1 -0.2,0.3 -0.3,0.4 -0.1,0.1 -0.1,0.2 -0.2,0.3 -0.2,0.3 -0.3,0.5 -0.4,0.8 -0.1,0.1 -0.1,0.3 -0.2,0.4 -0.1,0.3 -0.2,0.6 -0.3,0.9 0,0.1 0,0.2 0,0.3 0,0 0,0 0,0 l 7.4,1.3 c 2.4,0.4 4.9,0.6 7.4,0.6 3,0 5.7,-0.5 8.3,-1.4 5.2,-1.7 9.9,-4.6 13.6,-8.5 13.9,-14 19.9,-38.1 26.9,-54.1 z",
    id: "path77",
    style: {
      fill: "#0898b8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(493.84513,637.96908)",
    id: "text4866",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 48,
      lineHeight: 1.25,
      fontFamily: "Mukti",
      InkscapeFontSpecification: "Mukti",
      whiteSpace: "pre",
      shapeInside: "url(#rect4868)",
      fill: "#4d4d4d",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 686.10547,
    y: 211.92578,
    id: "tspan43842"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: "bold",
      fontFamily: "'DejaVu Sans'",
      InkscapeFontSpecification: "'DejaVu Sans, Bold'"
    },
    id: "tspan43840"
  }, "staff")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSignature);
export default __webpack_public_path__ + "static/media/brandSignature.77c036f1fa99dc41a5c45666a1e9f086.svg";
export { ForwardRef as ReactComponent };